import { useTranslation } from "react-i18next";
import styles from "./riskTables.module.scss";
import { withRiskMeasureUnit } from "../compare/utils";

// unitInValues: the table mixes percentages and ratios, so each value carries its unit
const DataTable = ({ data, columnName, is_bond, unitInValues = false }) => {
  const shown = (row, value) => (unitInValues ? withRiskMeasureUnit(row.label, value) : value);
  return (
    <div className={styles.tableContainer} style={{ backgroundColor: "white" }}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th className={styles.firstHeaderCell}>{columnName}</th>
            <th className={styles.headerCell}>{unitInValues ? "Prodotto" : "Prodotto %"}</th>
            {!is_bond && (
              <th className={styles.headerCell}>{unitInValues ? "Categoria" : "Categoria %"}</th>
            )}
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => {
            if (row.label !== "1-Mese") {
              return (
                <tr key={index} className={styles.tableRow}>
                  <td className={styles.labelCell}>{row.label}</td>
                  <td className={styles.valueCell}>
                    {row.product_value !== "-" ? `${shown(row, row.product_value)}` : "-"}
                  </td>
                  {!is_bond && (
                    <td className={styles.valueCell}>
                      {row.category_value !== null && row.category_value !== "-"
                        ? `${shown(row, row.category_value)}`
                        : "-"}
                    </td>
                  )}
                </tr>
              );
            }
            return null;
          })}
        </tbody>
      </table>
    </div>
  );
};

const RiskTablesContainer = ({ misureDiRischio, rendimentiCumulati, is_bond }) => {
  useTranslation();

  // Filter out specific items when is_bond is true
  const filteredMisureDiRischio = is_bond
    ? misureDiRischio.filter(
        (item) =>
          item.label !== "Tracking error volatility 3y" &&
          item.label !== "Information Ratio 3y"
      )
    : misureDiRischio;

  if (filteredMisureDiRischio.length === 0 && rendimentiCumulati.length === 0) {
    return null;
  }
  return (
    <>
      <div className={styles.container}>
        <DataTable data={filteredMisureDiRischio} columnName="Misure di Rischio" is_bond={is_bond} unitInValues />
        <DataTable data={rendimentiCumulati} columnName="Rend. Cumulati" is_bond={is_bond} />
      </div>
    </>
  );
};

export default RiskTablesContainer;
